import React, { useEffect, useRef, useState, useContext } from "react";
import PageNav from "../components/PageNav";
import { Notes } from "../svg/svgs";
import loadingSpin from '../images/loadingSpin.gif';
import { animated, useSpring } from "react-spring";
import Card from '../components/common/Card';
import { faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toTitleCase } from '../util/titleCase';
import DataTable from "../components/DataTable";
import BillingDataTable from "../components/BillingDataTable";



function BillHistory() {
    // const [displayDropdown, setDisplayDropdown] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [ fetchError, setFetchError ] = useState(false);
    const [ fetchEmpty, setFetchEmpty ] = useState(true);
    const firstname = JSON.parse(localStorage.getItem('studentInfo'))[0].firstname;


    const Heading = () => (
        <>
            <span className="text-2xl leading-7 text-white mt-1"> Payment History For {toTitleCase(firstname)} </span>
        </>
    );
    const pageSvg = () => (
        <>
            <Notes />
        </>
    )


    const transitionStyles = useSpring({
        to: [
        { opacity: 1, transform: 'translateX(0)' },
        ],
        from: { opacity: 0, transform: 'translateX(80px)' },
        config: { duration: 700 }
    });

    return (
        <>
            <animated.div style={transitionStyles} className="px-4 sm:flex sm:-mt-2 sm:px-0">
                <div className="w-full">
                    {/* <PageNav Heading={Heading} PageSvg={pageSvg} /> */}
                    <div className="pt-6 w-full">
                  
                        {loading ? 
                        <div className='flex justify-center w-full h-full my-24'>
                            <img src={loadingSpin} alt='loading...' />
                        </div> : 
                        <>
                             
                                <div className="mt-4">
                                    <BillingDataTable
                                        // arrayDataSets={fetchedPayments}
                                    />
                                </div>
                    
                            {
                                fetchEmpty === false &&
                                <div className="mt-4 mx-auto w-64">
                                    <Card>
                                        <div className='block text-center w-full p-6'>
                                            <FontAwesomeIcon icon={faBan} className='text-red-100'/>
                                            <div className='text-xs sm:text-sm text-red-300 font-semibold'>
                                                No Record Found
                                            </div>
                                            <div className='text-center text-blue-200 cursor-pointer mt-4'> 
                                                <span className='hover:text-blue-300 hover:underline' onClick={() => window.location.reload()}>
                                                    Try refresh 
                                                </span>
                                            </div>
                                        </div>
                                    </Card>
                                </div> 
                            }
                            {
                                fetchError &&
                                <div className="mt-4 mx-auto w-64">
                                    <Card>
                                        <div className='block text-center w-full p-6'>
                                            <FontAwesomeIcon icon={faBan} className='text-red-100'/>
                                            <div className='text-xs sm:text-sm text-red-300 font-semibold'>
                                                Oops! Something Went Wrong
                                            </div>
                                            <div className='text-center text-blue-200 cursor-pointer mt-4'> 
                                                <span className='hover:text-blue-300 hover:underline' onClick={() => window.location.reload()}>
                                                    Try refresh 
                                                </span>
                                            </div>
                                        </div>
                                    </Card>
                                </div> 
                            }
                            {errorMessage &&
                                <div className="mt-4 mx-auto w-64">
                                    <Card>
                                        <div className='block text-center w-full p-6'>
                                            <FontAwesomeIcon icon={faBan} className='text-red-100'/>
                                            <div className='text-xs sm:text-sm text-red-300 font-semibold'>
                                                Oops! {errorMessage}
                                            </div>
                                            <div className='text-center text-blue-200 cursor-pointer mt-4'> 
                                                <span className='hover:text-blue-300 hover:underline' onClick={() => window.location.reload()}>
                                                Try refresh 
                                                </span>
                                            </div>
                                        </div>
                                    </Card>
                                </div>
                            }                          
                        </>
                    }
                    </div>
                </div>
            </animated.div>
        </>
    )
}

export default BillHistory